import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { Image } from '../image/image'

@Component({
  selector: 'escuderia-badge',
  imports: [Image],
  templateUrl: './escuderia-badge.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EscuderiaBadge {
  escuderiaAvatar = input.required<string>()
  escuderiaName = input.required<string>()
  agenciaName = input.required<string>()
}
